import React from "react";
import { connect } from "react-redux";
import * as agent from "../agent";
import ClientDetailsForm from "./ClientDetailsForm.js";
import CarDetailsForm from "./CarDetailsForm.js";
import EditDebt from "./EditDebt.js";
import EditStats from "./EditStats.js";
import EditProgramForm from "./EditProgramForm.js";
import { CLIENT_LOADED, CONTRACT_UPDATED, MESSAGE_SENDED } from "../constants/actionTypes";
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Fade from '@material-ui/core/Fade';
import Typography from '@material-ui/core/Typography';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import PrimaryDivider from './PrimaryDivider';

const tabs = [
    { label: "Данные клиента", icon: <PersonAddIcon /> },
    { label: "Данные автомобиля", icon: <ExitToAppIcon /> },
    { label: "Программа займа", icon: <AccountBoxIcon /> },
    { label: "Долги и штрафы", icon: <AccountBoxIcon /> },
    { label: "Обращения", icon: <AccountBoxIcon /> }
];

class EditContract extends React.Component {

    constructor(props) {
        super();
        this.state = {
            value: 0
        };
    }
    componentDidMount() {
        this.fetchData();
    }
    fetchData() {
        agent.Client.get(this.props.id)
            .then(this.props.onLoad)
            .catch(err => alert(err));
    }
    switchTab = (e, value) => this.setState({ value });

    render() {
        const { value } = this.state;

        const { client = {}, carId, onClientDetailsSubmit, onCarDetailsSubmit, onEditDebt, onEditStats, onPenaltyUnfreeze, onPenaltyFreeze } = this.props;
        const { cars = [], isJuridicalPerson } = client;
        const car = cars.find(c => c._id === carId) || {};
        const { number_id,
                contract: {
                    _id: contractId,
                    creationDate,
                    prolongationDate,
                    clientCarsLength,
                    closingDate,
                    clientDetails = {},
                    carDetails = {},
                    programDetails = {},
                    penaltySum,
                    penaltyFrozen,
                    penaltyFrozenDays,
                    penaltyFreezingDate
                } = {} } = car;

        return (
            <Fade in={true}>
                <React.Fragment>
                    <Typography variant="h4">Редактировать договор</Typography>
                    <PrimaryDivider />
                    <Tabs value={value}
                          onChange={this.switchTab}
                          centered >
                        {tabs.map((tab, i) => <Tab key={i}
                                                   label={tabs[i].label}
                                                   icon={tabs[i].icon} />
                        )}
                    </Tabs>
                    <SwipeableViews axis="x" index={value}>
                        <div dir="x">
                            {value === 0 &&
                                <ClientDetailsForm client={client}
                                                   car_number={number_id}
                                                   clientDetails={clientDetails}
                                                   onClientDetailsSubmit={onClientDetailsSubmit}
                                                   isJur={isJuridicalPerson}
                                                   carId={carId}
                                                   editMode={true}
                                                   switchTab={this.switchTab}  />
                            }
                        </div>
                        <div dir="x">
                            {value === 1 &&
                                <CarDetailsForm car={car}
                                                onCarDetailsSubmit={onCarDetailsSubmit}
                                                contractId={contractId}
                                                carDetails={carDetails}
                                                isJur={isJuridicalPerson}
                                                editMode={true}
                                                switchTab={this.switchTab} />
                            }
                        </div>
                        <div dir="x">
                            {value === 2 &&
                                <EditProgramForm contractId={contractId}
                                                 creationDate={creationDate}
                                                 prolongationDate={prolongationDate}
                                                 isJur={isJuridicalPerson}
                                                 editMode={true}
                                                 switchTab={this.switchTab}
                                                 programDetails={programDetails} />
                            }
                        </div>
                        <div dir="x">
                            {value === 3 &&
                                <EditDebt contractId={contractId}
                                          prolongationDate={prolongationDate}
                                          isLT={programDetails.programType === "HOLD_LT"}
                                          sum={programDetails.sum}
                                          closingDate={closingDate}
                                          penaltyFrozen={penaltyFrozen}
                                          penaltyFrozenDays={penaltyFrozenDays}
                                          penaltyFreezingDate={penaltyFreezingDate}
                                          penaltySum={penaltySum}
                                          onEditDebt={onEditDebt}
                                          onPenaltyUnfreeze={onPenaltyUnfreeze}
                                          onPenaltyFreeze={onPenaltyFreeze} />
                            }
                        </div>
                        <div dir="x">
                            {value === 4 &&
                                <EditStats clientId={client._id}
                                           onEditStats={onEditStats}
                                           clientCarsLength={clientCarsLength}
                                           clientCarsClosedLength={clientCarsLength}/>
                            }
                        </div>
                    </SwipeableViews>
                </React.Fragment>
            </Fade>
        );
    }
}

const mapStateToProps = (state, {match}) => ({
    ...state.client,
    id: match.params.clientId,
    carId: match.params.carId,
});

const mapDispatchToProps = (dispatch, {match}) => ({
    onLoad: client =>
        dispatch({
            type: CLIENT_LOADED,
            payload: {
                ...client,
                id: match.params.clientId,
                carId: match.params.carId,
            }
        }),
    onClientDetailsSubmit: (loanData, clientDetails, swipe) =>
        agent.Contract.setClientDetails(loanData, clientDetails)
        .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract}))
        .then(swipe),
    onCarDetailsSubmit: (contractId, carDetails, swipe) =>
        agent.Contract.setCarDetails(contractId, carDetails)
        .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract}))
        .then(swipe),
    onProgramDetailsSubmit: (contractId, programDetails, swipe) =>
        agent.Contract.setProgramDetails(contractId, programDetails)
        .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract}))
        .then(swipe),
    onEditDebt: (contractId, data) =>
        agent.Contract.setDebt(contractId, data)
        .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract}))
        .then(() => dispatch({ type: MESSAGE_SENDED, payload: { text: "Изменения сохранены", type: "success" } })),
    onEditStats: (clientId, data) =>
        agent.Contract.setStats(clientId, data)
        .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract}))
        .then(() => dispatch({ type: MESSAGE_SENDED, payload: { text: "Изменения сохранены", type: "success" } })),
    onPenaltyUnfreeze: (contractId, date) =>
        agent.Contract.penaltyUnfreeze(contractId, date)
        .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract})),
    onPenaltyFreeze: (contractId, date) =>
        agent.Contract.penaltyFreeze(contractId, date)
        .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract})),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditContract);



// WEBPACK FOOTER //
// ./src/components/EditContract.js